import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUnsavedChanges } from '@/context/UnsavedChangesContext';

export const PreventNavigation = () => {
	const router = useRouter();
	const { hasUnsavedChanges, setPendingRoute, setIsModalOpen } =
		useUnsavedChanges();

	useEffect(() => {
		const handleRouteChangeStart = (url: string) => {
			if (!hasUnsavedChanges) return;

			setPendingRoute(url);
			setIsModalOpen(true);

			router.events.emit('routeChangeError');
			throw 'Navigation aborted.';
		};

		router.events.on('routeChangeStart', handleRouteChangeStart);

		return () => {
			router.events.off('routeChangeStart', handleRouteChangeStart);
		};
	}, [hasUnsavedChanges, router, setPendingRoute, setIsModalOpen]);

	return null;
};
